import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = 'unit'
    
    let options = { emulateJSON: false }

    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
      "ord": payload.event.ord,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }

    http.get(url, { params: params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getById ({commit}, payload) {
    let url = `unit/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  post ({commit}, payload) {
    let url = 'unit'
    let params = {
      "vin_number": payload.event.item.vin_number !== '' ? payload.event.item.vin_number : undefined,
      'brand': payload.event.item.brand,
      'model': payload.event.item.model,
      'unit_type_id': payload.event.item.unit_type_id,
      'unit_number': payload.event.item.unit_number,
      'site_id': payload.event.item.site_id,
      'comment': payload.event.item.comment,
      'owner': payload.event.item.owner,
      'owner_name': payload.event.item.owner === 'EXTERNAL' ? payload.event.item.owner_name : undefined,
      'plates': payload.event.item.plates,
      'mechanical_check': payload.event.item.mechanical_check,
      'smoke_check': payload.event.item.smoke_check,
      'certificate': payload.event.item.certificate,
      'wet_measure': payload.event.item.wet_measure,
      'dry_measure': payload.event.item.dry_measure,
      'capacity': payload.event.item.capacity,
      'kit': payload.event.item.kit,
      'operation_type': payload.event.item.operation_type
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  put ({commit}, payload) {
    let url = `unit/${payload.event.item.id}`
    let params = {
      "vin_number": payload.event.item.vin_number !== '' ? payload.event.item.vin_number : undefined,
      'brand': payload.event.item.brand,
      'model': payload.event.item.model,
      'unit_type_id': payload.event.item.unit_type_id,
      'unit_number': payload.event.item.unit_number,
      'site_id': payload.event.item.site_id,
      'comment': payload.event.item.comment,
      'owner': payload.event.item.owner,
      'owner_name': payload.event.item.owner === 'EXTERNAL' ? payload.event.item.owner_name : undefined,
      'plates': payload.event.item.plates,
      'mechanical_check': payload.event.item.mechanical_check,
      'smoke_check': payload.event.item.smoke_check,
      'certificate': payload.event.item.certificate,
      'wet_measure': payload.event.item.wet_measure,
      'dry_measure': payload.event.item.dry_measure,
      'capacity': payload.event.item.capacity,
      'kit': payload.event.item.kit,
      'operation_type': payload.event.item.operation_type
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delete ({commit}, payload) {
    let url = `unit/${payload.event.item.id}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delPlate ({commit}, payload) {
    let url = `plate/${payload.event.id}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelPlate', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  downloadUnitsTemplate ({commit}, payload) {
    let url = 'loading-unit-masive/template'
    let options = {
      emulateJSON : false
    }
    let params = {
      responseType: 'blob'
    }
    http.get(url, params, options)
    .then(
      response => {
        commit('onDownloadUnitsTemplate', {event: payload.event, response})
      },
      error => {
        commit('onFileError', {event: payload.event, error})
      }
      )
    },
  importUnits ({commit}, payload) {
    let url = 'loading-unit-masive/import'
    let params = {
      "file_id": payload.event.id
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onImportUnits', {event: payload.event, response})
        },
        error => {
          commit('onFileError', {event: payload.event, error})
        }
      )
  },
  saveUnits ({commit}, payload) {
    let url = 'loading-unit-masive/storage'
    let params = {
      "units": payload.event.items
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onSaveUnits', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
}

export default actions